import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import type { Maybe } from '@/types/globals';

export class DentureDetailsUtils {
	public static isDentureDetailsEnabled(procedureId: Maybe<number>): boolean {
		return procedureId === ProcedureEnum.Denture_Removable;
	}
}
